import { useState, useEffect } from "react";
import classes from "./AccordionButton.module.scss";

export default function AccordionButton(props: any) {
  //TODO Set a state and useEffect to handle de class
  const [activeClass, setActiveClass] = useState(classes["faq__icon"]);
  useEffect(() => {
    setActiveClass(
      props.active
        ? classes["faq__icon"] + " " + classes["active"]
        : props.active === false
        ? classes["faq__icon"]
        : classes["faq__icon__inactive"]
    );
  }, [props.active]);

  return (
    <div className={activeClass}>
      <span className={classes["faq__icon-vertical"]}></span>
      <span className={classes["faq__icon-horizontal"]}></span>
    </div>
  );
}
